import { useRoute } from 'vue-router'
import { computed, ComputedRef } from 'vue'
import { useMainStore } from '@/store/main'
import { testStatus } from '@/types/test-status'

interface NavigationConditions {
  isStarted: ComputedRef<boolean>
  showFooter: ComputedRef<boolean>
  couldNavigateNext: ComputedRef<boolean>
  couldNavigatePrev: ComputedRef<boolean>
  isLastPage: ComputedRef<boolean>
  isEnded: ComputedRef<boolean>
}

const getNavigationConditions = (): NavigationConditions => {
  /**
   * register store
   */
  const store = useMainStore()

  /**
   * get route properties
   */
  const route = useRoute()

  /**
   * @returns {boolean} isStarted
   */
  const isStarted = computed((): boolean => store.testStatus === testStatus.Started)

  /**
   * @returns {boolean} showFooter
   * check is router of result view
   */

  const showFooter = computed(() => route.name == 'result' || route.name == 'ambiguous')
  /**
   * @returns {booelan} couldNavigateNext
   */
  const couldNavigateNext = computed((): boolean => store.nextPage <= store.pages)
  /**
   * @returns {boolean} couldNavigatePrev
   */
  const couldNavigatePrev = computed((): boolean => store.prevPage >= 1 && store.testStatus !== testStatus.Ended)

  /**
   * @returns {boolean} isLastPage
   */
  const isLastPage = computed((): boolean => store.page === store.pages)

  /**
   * @returns {boolean} Ended
   */
  const isEnded = computed(
    (): boolean => store.testStatus === testStatus.Ended || store.testStatus === testStatus.Checkout,
  )

  return {
    isStarted,
    showFooter,
    couldNavigateNext,
    couldNavigatePrev,
    isLastPage,
    isEnded,
  }
}

export { getNavigationConditions }
